import React from 'react';

import { DownOutlined } from '@ant-design/icons';
import {
  Button as AntdButton,
  Dropdown as AntdDropdown,
  MenuProps,
} from 'antd';

import { ConditionsReactivateEtatDto, EtatDto } from 'lib_api/lib/api/gen';

import { useModal } from 'hooks/modal/useModal';

import ModalDesactivation from '../Modals/ModalDesactivation/ModalDesactivation';
import ModalReactivation from '../Modals/ModalReactivation/ModalReactivation';

import ConditionReactivateEtat from './ConditionReactivateEtat/ConditionReactivateEtat';
import ModalDetails from './Modals/ModalDetails';
import ModalUpdate from './Modals/ModalUpdate';
import UsesEtat from './UsesEtat/UsesEtat';
import { useChangeValidityEtat } from './utils';

interface CellDetailsAndActionsProps {
  etat: EtatDto;
  refreshDashboard: () => void;
}

function CellDetailsAndActions({
  etat,
  refreshDashboard,
}: CellDetailsAndActionsProps): React.ReactElement {
  const modalDetails = useModal();
  const modalModification = useModal();
  const modalDeprecate = useModal();

  const {
    submitReactivateEtat,
    submitDeprecateEtat,
    conditionsReactivateEtat,
    getUsesEtat,
  } = useChangeValidityEtat();

  const conditionUnlock = (
    conditions?: ConditionsReactivateEtatDto,
  ): boolean => {
    return conditions?.reactivationAvailable ?? false;
  };

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: 'Modifier',
      onClick: modalModification.open,
    },
    {
      key: '2',
      label: etat.valid ? "Désactiver l'état" : "Activer l'état",
      onClick: modalDeprecate.open,
    },
  ];

  return (
    <>
      <AntdButton onClick={modalDetails.open}>Détails</AntdButton>
      <ModalDetails
        etat={etat}
        visible={modalDetails.visible}
        close={modalDetails.close}
      />
      <AntdDropdown menu={{ items }} className="menuActions">
        <AntdButton>
          Actions <DownOutlined />
        </AntdButton>
      </AntdDropdown>
      <ModalUpdate
        refreshDashboard={refreshDashboard}
        etat={etat}
        visible={modalModification.visible}
        close={modalModification.close}
      />

      {etat.valid ? (
        <ModalDesactivation
          idCorrelation={etat.idCorrelation}
          titleModal="Désactiver l'état"
          submitDeprecate={submitDeprecateEtat}
          visible={modalDeprecate.visible}
          close={modalDeprecate.close}
          callAfterSubmit={refreshDashboard}
          usesRequest={getUsesEtat}
          componentUses={UsesEtat}
        />
      ) : (
        <ModalReactivation
          idCorrelation={etat.idCorrelation}
          titleModal="Réactiver l'état"
          visible={modalDeprecate.visible}
          close={modalDeprecate.close}
          callAfterSubmit={refreshDashboard}
          conditionRequest={conditionsReactivateEtat}
          componentConditions={ConditionReactivateEtat}
          conditionUnlock={conditionUnlock}
          reactivateRequest={submitReactivateEtat}
        />
      )}
    </>
  );
}

export default CellDetailsAndActions;
